import React from "react";
import { Skeleton } from "@ann/web-components";
import {
  FirstContainer,
  SecondContainer,
  ThirdContainer,
} from "../../ChatPanel.styled";

const AgentViewSkeleton = () => (
  <>
    <FirstContainer>
      <Skeleton height="32px" width="32px" borderRadius="50%" />
      <Skeleton height="24px" width="180px" borderRadius="6px" />
      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
        <Skeleton height="16px" width="16px" borderRadius="4px" />
        <Skeleton height="14px" width="200px" borderRadius="4px" />
      </div>
      <Skeleton height="16px" width="90%" borderRadius="4px" />
      <Skeleton height="16px" width="70%" borderRadius="4px" />
    </FirstContainer>
    <SecondContainer>
      <Skeleton height="80px" width="100%" borderRadius="8px" />
    </SecondContainer>
    <ThirdContainer>
      {[1, 2, 3, 4].map((i) => (
        <Skeleton key={i} height="84px" borderRadius="8px" width="100%" />
      ))}
    </ThirdContainer>
  </>
);

export default AgentViewSkeleton;
